import { gray1300 } from '@mentimeter/ragnar-colors';
import type { KosmosFontSize } from '@mentimeter/ragnar-dsc';
import * as React from 'react';
import { Avatar as A } from '@mentimeter/ragnar-ui/avatar';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Dark } from '@mentimeter/ragnar-ui/themes';
import { Tooltip } from '@mentimeter/ragnar-ui/tooltip';

export type AvatarSizeT = 1 | 2 | 3 | 4;
interface SizeItem {
  fontSize: KosmosFontSize;
  width: string;
  height: string;
  borderWidth: number;
}

export const AVATAR_SIZE_MAP: Record<AvatarSizeT, SizeItem> = {
  '1': {
    fontSize: '62.5',
    width: '1.25rem',
    height: '1.25rem',
    borderWidth: 1,
  },
  '2': {
    fontSize: '62.5',
    width: '1.5rem',
    height: '1.5rem',
    borderWidth: 2,
  },
  '3': {
    fontSize: '87.5',
    width: '2rem',
    height: '2rem',
    borderWidth: 2,
  },
  '4': {
    fontSize: '87.5',
    width: '2.5rem',
    height: '2.5rem',
    borderWidth: 2,
  },
};
interface AvatarT {
  id?: string;
  size?: AvatarSizeT;
  initials: string;
  name: string;
  children?: React.ReactNode;
  isPresenting?: boolean | undefined;
  bg?: string;
  onAvatarClick?: () => void;
  profilePictureUrl?: string;
  className?: string;
  tooltipSide?: 'top' | 'bottom' | 'left' | 'right' | undefined;
}

export const Avatar = ({
  id,
  name,
  initials,
  size = 3,
  isPresenting,
  bg,
  onAvatarClick,
  children,
  className,
  profilePictureUrl,
  tooltipSide = 'bottom',
}: AvatarT) => {
  const { ...styles } = AVATAR_SIZE_MAP[size || 3];
  return (
    <Tooltip
      trigger={
        <Box>
          <A
            type="user"
            initials={initials.toUpperCase()}
            name={name}
            id={id}
            {...styles}
            badge={isPresenting ? 'play' : undefined}
            onClick={onAvatarClick}
            borderStyle="solid"
            borderWidth="1px"
            borderColor="bg"
            color={gray1300}
            profilePictureUrl={profilePictureUrl}
            extend={() => ({
              cursor: onAvatarClick ? 'pointer' : undefined,
            })}
            {...(bg && { bg })}
            className={className}
          />
        </Box>
      }
      side={tooltipSide}
      className="dark bg-surface fill-surface"
    >
      {children && (
        <Dark>
          <Box bg="surface">{children}</Box>
        </Dark>
      )}
    </Tooltip>
  );
};
